<script lang="ts" setup>
import { MoveWareHouseHeaderKey, TableContentProperty } from '../../interface/tableContentHeaders';
import TableCell from '../TableCell.vue';
import { TableContentItem } from '../../interface/tableContentItems';
import { i18n } from '@/i18n';
import RegisterUnmanagedBusinessButton from './RegisterUnmanagedBusinessButton.vue';
import { MoveWarehouseTableContentViewModel } from './moveWarehouseTableContentViewModel';
import { computed } from 'vue';

const t = i18n.t;

// props
const props = withDefaults(
  defineProps<{
    header: TableContentProperty;
    moveWarehouseHeaderKey: MoveWareHouseHeaderKey;
    item: TableContentItem;
    headerIndex: number;
    accumulationTableContentWidth: number;
    isVariableWidth: boolean;
    isAllSelected: boolean;
    stableColumnCount: number;
    isEditing: boolean;
    isBold: boolean;
    isChecked: boolean;
    isCheckedBusinessId: boolean;
  }>(),
  {}
);

// emits
const emits = defineEmits<{
  (e: 'onClickNarrow'): void;
}>();

const moveWarehouseTableContentViewModel = new MoveWarehouseTableContentViewModel();
const textAlign = computed(() => {
  return props.header.propertyPath?.propertyType === 'number' ? 'right' : 'left';
});
</script>

<template>
  <TableCell
    :class="[moveWarehouseTableContentViewModel.isSticky(stableColumnCount, headerIndex) ? 'sticky-content' : '']"
    :style="{
      left: moveWarehouseTableContentViewModel.calcStickyDiff(stableColumnCount, headerIndex, accumulationTableContentWidth),
    }"
    class="table-cell base-table__body--fixed"
    :text-align="textAlign"
    :table-content-property="header"
    :tool-tip-value="moveWarehouseTableContentViewModel.displayOrderItem(moveWarehouseHeaderKey, item)"
    :is-highlighted="props.isChecked || props.isCheckedBusinessId"
  >
    <template v-if="moveWarehouseHeaderKey === 'differenceAmount'">
      <span
        class="table-cell-content"
        :class="{
          'differenceAmount--positive': item.differenceAmount >= 0,
          'differenceAmount--negative': item.differenceAmount < 0,
        }"
      >
        {{ moveWarehouseTableContentViewModel.displayOrderItem(moveWarehouseHeaderKey, item) }}
      </span>
    </template>
    <template v-else>
      <span class="table-cell-content">
        {{ moveWarehouseTableContentViewModel.displayOrderItem(moveWarehouseHeaderKey, item) }}
      </span>
    </template>
  </TableCell>
</template>

<style lang="scss" scoped>
.table-cell-content {
  font-family: Noto Sans JP;
  font-size: $fontSizeSS;
  font-weight: 400;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.differenceAmount {
  &--positive {
    color: $textDefault;
  }

  &--negative {
    color: $semanticError;
  }
}
</style>
